import { useTranslation } from 'libs/i18n'
import { useNavigate, useSearchParams } from 'libs/router'
import { useUserRoles } from 'shared/hooks'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'
import type { BookingItem } from '../types/bookings.types'

type UseContextMenuOptionsProps = {
	handleSmsReminder: (id: number) => void
	handleEmailWelcome: (id: number) => void
	handleEmailReminder: (id: number) => void
	handleConfirm: (ids: number[]) => void
	handleUnconfirm: (ids: number[]) => void
}

export const useBookingPath = () => {
	const [searchParams] = useSearchParams()
	const query = searchParams.toString()

	return (id: number) =>
		query ? `${routes.bookingEdit(String(id))}?${query}` : routes.bookingEdit(String(id))
}

export const useContextMenuOptions = ({
	handleSmsReminder,
	handleEmailWelcome,
	handleEmailReminder,
	handleConfirm,
	handleUnconfirm
}: UseContextMenuOptionsProps) => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const bookingPath = useBookingPath()
	const { isStaff, isUser } = useUserRoles()

	return (booking: BookingItem): Option[] => [
		{
			label: t('Edit'),
			action: () => navigate(bookingPath(booking.id))
		},
		...(isUser && booking.confirmed != null
			? [
					{
						label: !booking.confirmed ? t('Confirm') : t('Unconfirm'),
						action: () =>
							!booking.confirmed ? handleConfirm([booking.id]) : handleUnconfirm([booking.id])
					}
				]
			: []),
		...(isStaff
			? [
					{ label: t('Send welcome email'), action: () => handleEmailWelcome(booking.id) },
					{ label: t('Send email reminder'), action: () => handleEmailReminder(booking.id) },
					{ label: t('Send product confirm email'), action: () => handleSmsReminder(booking.id) }
				]
			: [])
	]
}
